module.exports = __webpack_public_path__ + "static/media/45.c9af161d.png";